import store from 'store/index'
import api from 'auth/api'
import handleErrors from './handleErrors'
import Cookie from 'js-cookie'
import { useAuth } from 'auth/auth'
const myPost = async (url, configuration) => {
  const auth = useAuth()
  if (!auth) await api.trySilentRefresh()
  const token = Cookie.get('accessToken')
  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `bearer ${token}`,
  })
  const newConfiguration = {
    ...configuration,
    headers,
    method: 'POST',
  }
  return fetch(url, newConfiguration).then(handleErrors)
}

export default myPost
